import React from "react";
import { Square5Style } from "./css/Square5Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const Template = (props) => {
  return (
    <Square5Style>
      <div className="poster five one-by-one">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="sidepanel five flex-row-left">
          <div className="photo-container">
            <div className="photo">
              <TemplateImage slideType={props.slideType} file={props.file} />
            </div>
          </div>
        </div>
        <div className="text-wrapper flex-row-left">
          <TemplateText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Square5Style>
  );
};

export default Template;
